import type { AlignKind, StackingCommand } from '@peruselab/structure-editor/domain/objectAlignment';
import type { IconName } from '../Icon';

export const ORDER: readonly [StackingCommand, IconName][] = [
  ['toFront', 'flipToFront'],
  ['forward', 'moveSelectionUp'],
  ['backward', 'moveSelectionDown'],
  ['toBack', 'flipToBack']
];

export const ALIGN: readonly [AlignKind, IconName, string][] = [
  ['alignLeft', 'alignHorizontalLeft', 'left'],
  ['alignCenterH', 'alignHorizontalCenter', 'centerHorizontal'],
  ['alignRight', 'alignHorizontalRight', 'right'],
  ['alignTop', 'alignVerticalTop', 'top'],
  ['alignMiddle', 'alignVerticalCenter', 'middle'],
  ['alignBottom', 'alignVerticalBottom', 'bottom']
];

export const DISTRIBUTE: readonly [AlignKind, IconName, string][] = [
  ['distributeHorizontal', 'horizontalDistribute', 'distributeHorizontal'],
  ['distributeVertical', 'verticalDistribute', 'distributeVertical']
];
